<template lang="pug">
.search-form-sticky-wrapper(:class="{ sticky: sticky, 'sticky--advanced': advancedSearchVisible }")
	.search-form
		form.search-form__form(@submit.prevent="startSearch")
			.search-form__field-wrap
				VueRadioGroup#search-saleValues(legend="Értékesítés típusa", :isLegendHidden="true", v-model="model.saleType", :options="saleValues", mobileInline)
			.search-form__field-wrap
				VueSelect#search-re-type.search-form__property-type(v-model="model.propertyType")
					VueSelectOption(v-for="(item, index) in realEstateValues", :value="item.key", :text="item.value", :index="index", label-id="label1", :key="item.key")
			.search-form__field-wrap
				VueTooltip(ref="searchTooltip", placement="right")
					SearchAutosuggest(
						slot="trigger",
						v-model="model.selectedTags",
						:placeholder="$t('ANYIT.placeSearchExample')",
						:suggestions="searchItems",
						label-prop="value",
						@search="autosuggest",
						@tab="onSearchInputTab"
					)
					template(slot="content") {{ $t('ANYIT.placeSearchTooltip') }}
			.search-form__field-wrap
				SearchRangeInput#price-per-sm(ref="priceRangeInput", v-model="price", :legend="priceLegend", @second-input-tab="onPriceTab")
					template(#postfix) {{ pricePostfix }}
				SearchRangeInput#square-meter.size-input(ref="areaRangeInput", v-model="area", :legend="areaLegend", @first-input-shift-tab="showPriceMin")
					template(#postfix) m #[sup 2]
			VueButton.search-form__cta(buttonType="highlighted", @keydown.tab.shift="showAreaMin") {{ $t('ANYIT.search') }}
			template(v-if="advancedSearchLinkVisible")
				button.search-form__advanced(type="button", @click="showAdvancedSearch")
					span {{ $t('ANYIT.advancedSearch') }}
					svg(width="8", height="6", viewBox="0 0 8 6", fill="none", xmlns="http://www.w3.org/2000/svg")
						path(d="M0.943333 0.473633L4 3.5303L7.05667 0.473633L8 1.41697L4 5.41697L0 1.41697L0.943333 0.473633Z")
		SearchAdvanced(v-show="advancedSearchVisible", ref="advancedSearch", :value="advanced", @input="setAdvancedModelAndSearch", :property-type="model.propertyType")
</template>
<script>
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueInput from '@ui-common/vue-input';
import VueTooltip from '@ui-common/vue-tooltip';
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueButton from '@ui-common/vue-button';
import isMobile from '../../../common/js/is-mobile/is-mobile';
import SearchRangeInput from './search-range-input';
import SearchAutosuggest from './search-autosuggest';
import SearchAdvanced from './search-advanced';
import searchApi from '../../../api/search-api';
import * as R from 'ramda';
import label from '../libs/range-label';
import niceUrlService from '../../../common/js/url/nice-url-service';
import restUrlService from '../../../common/js/url/rest-url-service';
import legacyUrlService from '../../../common/js/url/legacy-url-service';
import { parseQueryString } from '../../../common/js/url/url-utils';
import getPosition from '../../../common/js/get-position/get-position';
import { ORDER_TYPES } from '../../../common/js/constants/constants';
import { mapState, mapActions } from 'vuex';
const hasQueryStringParam = R.prop(R.__, parseQueryString(window.location.search));
const ADVANCED_SEARCH_REAL_ESTATE_TYPES = ['flat', 'house', 'flatPlusHouse'];
const isBlank = R.either(R.isNil, R.isEmpty);
const SALE_VALUES = ['forSell', 'forRent'];
const REAL_ESTATE_VALUES = [
	'flatPlusHouse',
	'flat',
	'house',
	'parcel',
	'garage',
	'office',
	'shop',
	'tourism',
	'industrial',
	'agricultural',
	'parcelForInnovation',
	// 'projectEstate',
	'publicInstitution'
];
const SUGGEST_MIN_LENGTH = 3;
const EMPTY_MODEL = {
	order: ORDER_TYPES[2],
	priceMaximum: null,
	priceMinimum: null,
	saleType: SALE_VALUES[0],
	propertyType: REAL_ESTATE_VALUES[0],
	areaMaximum: null,
	areaMinimum: null,
	selectedTags: [],
	page: 0,
	isOwnedByFactoring: false
};
export default {
	mixins: [isMobile],
	data: () => ({
		sticky: false,
		advancedSearchVisible: false,
		model: EMPTY_MODEL,
		fromOpen: false,
		advanced: {},
		utmParams: {},
		searchItems: [],
		price: {
			min: null,
			max: null
		},
		area: {
			min: null,
			max: null
		},
		isSimple: true
	}),
	props: {
		redirect: {
			type: Boolean,
			required: true
		},
		modalView: {
			type: Boolean,
			required: true
		}
	},
	watch: {
		'model.propertyType'(val) {
			if (!ADVANCED_SEARCH_REAL_ESTATE_TYPES.includes(val)) {
				this.advancedSearchVisible = false;
			}
		},
		advancedSearchLinkVisible(val) {
			if (!val) {
				this.advanced = {};
			}
		},
		price(val) {
			this.model.priceMinimum = val.min;
			this.model.priceMaximum = val.max;
		},
		area(val) {
			this.model.areaMinimum = val.min;
			this.model.areaMaximum = val.max;
		},
		model(val) {
			if (val.priceMinimum != this.price.min) {
				this.price = Object.assign({}, this.price, { min: val.priceMinimum });
			}
			if (val.priceMaximum != this.price.max) {
				this.price = Object.assign({}, this.price, { max: val.priceMaximum });
			}
			if (val.areaMinimum != this.area.min) {
				this.area = Object.assign({}, this.area, { min: val.areaMinimum });
			}
			if (val.areaMaximum != this.area.max) {
				this.area = Object.assign({}, this.area, { max: val.areaMaximum });
			}
		},
		async advancedSearchVisible(val) {
			this.setSticky();
			if (val) {
				await this.$nextTick();
				this.$scrollTo(this.$el);
			}
		}
	},
	components: {
		VueButton,
		VueSelect,
		VueSelectOption,
		VueInput,
		VueTooltip,
		SearchRangeInput,
		SearchAutosuggest,
		SearchAdvanced,
		VueRadioGroup
	},
	computed: {
		...mapState('search', ['searchResults']),
		pricePostfix() {
			return this.model.saleType == SALE_VALUES[0] ? this.$t('ANYIT.millionHUF') : this.$t('ANYIT.thousandHUF');
		},
		advancedSearchLinkVisible() {
			return ADVANCED_SEARCH_REAL_ESTATE_TYPES.includes(this.model.propertyType);
		},
		priceLegend() {
			return this.$t('ANYIT.price').toLowerCase();
		},
		areaLegend() {
			return this.$t('ANYIT.areaSearch');
		},
		saleValues() {
			return SALE_VALUES.map((sale) => ({
				key: sale,
				value: this.$t(`ANYIT.${sale}`)
			}));
		},
		realEstateValues() {
			return REAL_ESTATE_VALUES.map((realEstate) => ({
				key: realEstate,
				value: this.$t(`ANYIT.${realEstate}`)
			}));
		},
		propertyTypeText() {
			return this.$t(`ANYIT.${this.model.propertyType}`);
		},
		selectedTagsText() {
			const pluckValue = R.pluck('value');
			return pluckValue(this.model.selectedTags);
		},
		toAngularPropertyType() {
			return R.indexOf(this.model.propertyType, REAL_ESTATE_VALUES);
		},
		priceLabel() {
			return label({ min: this.model.priceMinimum, max: this.model.priceMaximum, legend: this.priceLegend });
		},
		areaLabel() {
			return label({ min: this.model.areaMinimum, max: this.model.areaMaximum, legend: this.areaLegend });
		},
		isComissionsPage() {
			return !!window.searchParams?.comissionIds;
		}
	},
	methods: {
		...mapActions('search', ['setSearchResults', 'setSearchModel']),
		showAdvancedSearch() {
			if (this.redirect) {
				this.search(true, true);
			} else {
				this.advancedSearchVisible = !this.advancedSearchVisible;
			}
		},
		resetPage() {
			this.model.page = 0;
			window.ipEventBus.publish('change-page', this.model.page + 1);
		},
		startSearch() {
			this.resetPage();
			if (this.advancedSearchVisible) {
				this.$refs.advancedSearch.send();
			} else {
				this.isSimple = true;
				this.search();
			}
		},
		setAdvancedModelAndSearch(advancedModel) {
			this.isSimple = false;
			this.advanced = advancedModel;
			this.resetPage();
			this.search();
		},
		onSearchInputTab() {
			this.showPriceMin();
			this.closeTooltip();
		},
		onPriceTab() {
			this.showAreaMin();
		},
		closeTooltip() {
			this.$refs.searchTooltip.close();
		},
		showAreaMin() {
			this.$refs.areaRangeInput.showInputs();
		},
		showPriceMin() {
			this.$refs.priceRangeInput.showInputs();
		},
		async sendSearch() {
			const mergedModel = R.mergeAll([this.model, this.advanced]);
			const params = restUrlService.createUrlFromState(mergedModel);
			window.ipEventBus.publish('change-page', this.model.page + 1);
			try {
				if (!this.fromOpen) {
					this.advancedSearchVisible = false;
					if (this.modalView) {
						this.$closeModal('search-modal');
					}
				} else {
					this.fromOpen = false;
				}
				const response = await searchApi.search(params);
				const misses = response.data.misses;
				if (misses) {
					console.warn("comission ids not found in database:", misses);
				}
				this.setSearchResults(response.data);
				this.setSearchModel({ model: R.clone(this.model), advanced: R.clone(this.advanced) });
				this.sendAnalytics();
			} catch (err) {
				window.ipEventBus.publish('show-error', {
					message: 'technicalError'
				});
			}
		},
		sendAnalytics() {
			const salesType = this.saleValues.find((saleType) => saleType.key == this.model.saleType).value;
			const propertySize = this.model.areaMinimum || this.model.areaMaximum ? this.areaLabel : '';
			const propertyPrice = this.model.priceMinimum || this.model.priceMaximum ? this.priceLabel : '';
			this.$gtm.trackEvent({
				event: 'propertySearchResult',
				salesType,
				propertySize,
				propertyType: this.propertyTypeText,
				propertyLocation: this.selectedTagsText.join(' | '),
				propertyPrice
			});
			const event = this.isSimple ? 'propertySearchResult' : 'propertySearchResultwithFilter';
			this.$gtm.trackEvent({
				event,
				searchNo: this.searchResults.hits.totalElements
			});
		},
		search(pushUrl = true, openAdvanced) {
			const mergedModel = R.mergeAll([this.model, this.advanced]);
			const searchResultUrl = niceUrlService.createUrlFromState(mergedModel);
			if (openAdvanced) {
				window.sessionStorage.setItem('dataFromOpen', JSON.stringify({ openAdvanced: true }));
			}
			if (this.redirect) {
				window.location.href = searchResultUrl;
			} else {
				switch (pushUrl) {
					case true:
						history.pushState(
							{ simple: R.clone(this.model), advanced: R.clone(this.advanced) },
							'',
							niceUrlService.createUrlFromState(mergedModel)
						);
						this.sendSearch();
						break;
					case false:
						history.replaceState(
							{ simple: R.clone(this.model), advanced: R.clone(this.advanced) },
							'',
							niceUrlService.createUrlFromState(R.mergeAll([this.model, this.advanced, this.utmParams]))
						);
						this.sendSearch();
						break;
					case 'comissions':
						history.replaceState(
							{ simple: R.clone(this.model), advanced: R.clone(this.advanced) },
							'',
							`${window.location.pathname}?oldal=${this.model.page}`
						);
						this.sendSearch();
						break;
					default:
						this.sendSearch();
				}
			}
		},
		fromAngularPropertyType(propertyType) {
			return REAL_ESTATE_VALUES[propertyType];
		},
		openAngularModal({ type, data }) {
			window.ipEventBus.publish('open-search-popup', { type, data });
		},
		async autosuggest(query) {
			if (query && query.length >= SUGGEST_MIN_LENGTH) {
				try {
					const response = await searchApi.getSuggestions(query);
					if (response) {
						this.searchItems = response.data;
					}
				} catch (err) {
					console.error(err);
					console.error('Autosuggest error');
				}
			}
		},
		handleAngularData() {
			window.ipEventBus.subscribe('send-search-popup-data', (channel, data) => {
				if (data.ingatlantipusa) {
					this.model.propertyType = this.fromAngularPropertyType(data.ingatlantipusa);
				}
				if (data.selectedTags) {
					this.model.selectedTags = R.clone(data.selectedTags);
				}
				if (data.arMinimum || data.arMaximum) {
					this.price = { min: data.arMinimum, max: data.arMaximum };
				}
				if (data.meretMinimum || data.meretMaximum) {
					this.area = { min: data.meretMinimum, max: data.meretMaximum };
				}
			});
		},
		async handleUrlData() {
			if (window.location.search && !hasQueryStringParam('token')) {
				const { simple, advanced, utmParams } = niceUrlService.createStateFromUrl();
				this.utmParams = utmParams;
				if(R.isEmpty(simple) && R.isEmpty(advanced)) return;
				R.isEmpty(advanced) ? (this.isSimple = true) : (this.isSimple = false);
				const dataFromOpenString = window.sessionStorage.getItem('dataFromOpen');
				if (dataFromOpenString) {
					const dataFromOpen = JSON.parse(dataFromOpenString);
					if (dataFromOpen.openAdvanced) {
						this.fromOpen = true;
						this.advancedSearchVisible = true;
						await this.$nextTick();
						this.$openModal(this.$refs.advancedSearch, 'search-modal');
					}
					window.sessionStorage.removeItem('dataFromOpen');
				}
				this.model = Object.assign({}, EMPTY_MODEL, simple);
				this.advanced = advanced;
				window.ipEventBus.publish('change-order-url', this.model.order);
				this.search(false);
			}
		},
		handlePagingData() {
			window.ipEventBus.subscribe('change-page', (channel, page) => {
				if (this.model.page != page - 1) {
					this.model.page = page - 1;
					let pushUrl = true;
					if (this.isComissionsPage) {
						pushUrl = 'comissions';
					}
					this.search(pushUrl);
				}
			});
			window.ipEventBus.subscribe('change-order', (channel, order) => {
				if (this.model.order != order) {
					this.resetPage();
					this.model.order = order;
					this.search();
				}
			});
		},
		async handleSearchParams() {
			const locations = R.when(R.complement(isBlank), R.split('|'), window.searchParams.hely);
			const locationTypes = R.when(R.complement(isBlank), R.split('|'), window.searchParams.mapType);
			if (locations && locationTypes) {
				const mapIndexed = R.addIndex(R.map);
				const createSelectedTag = R.applySpec({ value: R.nthArg(0), type: R.pipe(R.nthArg(1), R.nth(R.__, locationTypes)) });
				const merged = mapIndexed(createSelectedTag, locations);
				this.model.selectedTags = R.defaultTo(this.model.selectedTags, merged);
			}
			this.model.saleType = R.defaultTo(this.model.saleType, window.searchParams.ertekesitestipusa);
			this.model.propertyType = R.defaultTo(this.model.propertyType, window.searchParams.ingatlantipusa);
			this.price = {
				min: R.defaultTo(null, parseInt(window.searchParams.arMinimum, 10)),
				max: R.defaultTo(null, parseInt(window.searchParams.arMaximum, 10))
			};
			this.area = {
				min: R.defaultTo(null, parseInt(window.searchParams.meretMinimum, 10)),
				max: R.defaultTo(null, parseInt(window.searchParams.meretMaximum, 10))
			};
			this.model.isOwnedByFactoring = R.defaultTo(null, searchParams.isOwnedByFactoring);
			await this.$nextTick();
			this.search(null);
		},
		setSticky() {
			this.sticky = getPosition(this.$el).y < 0 && !this.redirect && this.searchResults?.hits?.content?.length;
		},
		handleSticky() {
			this.setSticky();
			document.addEventListener('scroll', this.setSticky);
		},
		handleLegacyUrl() {
			if (window.location.hash) {
				const { simple, advanced } = legacyUrlService.createStateFromUrl();
				this.model = Object.assign({}, EMPTY_MODEL, simple);
				this.advanced = advanced;
				window.ipEventBus.publish('change-order-url', this.model.order);
				this.search();
			}
		}
	},
	mounted() {
		this.handleSticky();
		if (this.isComissionsPage) {
			const params = new URLSearchParams(window.location.search)
			const page = params.get('oldal');
			if (page) {
				this.model.page = parseInt(page);
			}
		}
	},
	created() {
		window.onpopstate = (event) => {
			this.model = R.clone(event.state.simple);
			this.advanced = R.clone(event.state.advanced);
			this.sendSearch();
		};
		if (window.searchParams) {
			this.handleSearchParams();
		} else {
			this.handleLegacyUrl();
			this.handleUrlData();
		}
		this.handleAngularData();
		this.handlePagingData();
	}
};
</script>
<style src="@ui-common/vue-select/dist/vue-select.css"></style>
<style src="@ui-common/vue-radio-group/dist/vue-radio-group.css"></style>
<style src="@ui-common/vue-button/dist/vue-button.css"></style>
<style lang="css" scoped="">
@import '../../../common/variables.pcss';

.search-wrapper-section .search-form {
	background-color: var(--grey-f5);
	padding: 15px 116px;
}

.search-form {
	padding: 16px;

	@media (--desktop) {
		background: rgba(255, 255, 255, 0.6);
		border-radius: 5px;
		margin-bottom: 2px;
		padding: 15px 35px;
	}
}

.search-form-sticky-wrapper {
	min-height: 81px;
}

.search-form-sticky-wrapper.sticky > .search-form {
	max-height: 100%;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 55;
}

.search-form-sticky-wrapper.sticky.sticky--advanced > .search-form {
	overflow-y: auto;
}

.search-form-sticky-wrapper.sticky--advanced .search-form__advanced svg {
	transform: rotate(180deg);
}

.search-form__form {
	display: flex;
	flex-direction: column;

	@media (--desktop) {
		align-items: center;
		flex-direction: row;
		justify-content: center;
	}
}

.search-form__field-wrap {
	margin-bottom: 8px;

	@media (--desktop) {
		align-items: center;
		display: flex;
		margin-bottom: 0;
	}
}

.search-form__property-type >>> .sf-select__options-wrapper {
	width: auto;
	max-width: none;
	top: 44px;
}

.search-form__property-type >>> .sf-select__options-wrapper ul {
	margin-top: 0;
	text-align: left;
}

.search-form__property-type >>> .sf-select__options li {
	white-space: nowrap;
}

.search-form >>> .sf-radio-group {
	@media (--desktop) {
		margin-right: 25px;
		max-width: 60px;
	}
}

.search-form >>> .sf-radio-group__container {
	@media (--desktop) {
		flex-direction: column;
	}
}

.search-form >>> .sf-radio-group__label {
	line-height: 26px;
}

.search-form >>> .sf-radio-group__label::before {
	top: 2px;
}

.search-form >>> .sf-radio-group__label::after {
	top: 6px;
}

.search-form >>> .sf-select {
	@media (--desktop) {
		width: 140px;
	}
}

.search-form >>> .sf-select-wrapper {
	height: 44px;
}
.search-form >>> .sf-select__button-wrapper::before {
	top: 15px;
}

.search-form >>> .sf-select__button-wrapper button {
	border-bottom-right-radius: 0;
	border-top-right-radius: 0;
}

.search-form >>> .sf-select__button-wrapper button:focus {
	outline: none;
}

.search-form >>> .sf-tooltip {
	margin: 0;
	width: 100%;
}

/*mobile*/
.search-form__trigger-wrap {
	display: flex;
	flex-direction: column;
	margin-top: 20px;
}

.search-form__trigger-wrap button {
	background: var(--white);
	border-radius: 4px;
	border: 1px solid var(--grey-c5);
	box-sizing: border-box;
	color: var(--text-primary);
	font-family: 'regular', Arial, sans-serif;
	font-size: 16px;
	margin: 0 0 8px 0;
	min-height: 44px;
	padding: 10px 15px;
	text-align: left;
	transition: 0.2s;
}

.type-trigger {
	position: relative;

	&::before {
		border-bottom: 1px solid #9e9e9e;
		border-left: 1px solid #9e9e9e;
		border-right: none;
		border-top: none;
		content: '';
		display: block;
		height: 9px;
		position: absolute;
		right: 18px;
		top: 13px;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		transition: margin-top 0.3s linear;
		width: 9px;
	}
}

.search-form__trigger-wrap .place-trigger {
	display: flex;
	flex-wrap: wrap;
	padding: 5px 10px;
}

.trigger-tag {
	background-color: var(--green);
	border-radius: 4px;
	color: var(--white);
	cursor: default;
	font-size: 12px;
	margin: 5px;
	max-width: 100%;
	overflow: hidden;
	padding: 4px;
	position: relative;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.trigger-placeholder {
	color: #a4a4a4;
	padding: 5px;
}
</style>
<style lang="css">
@import '../../../common/variables.pcss';

.tippy-tooltip {
	background-color: var(--blue);
	display: none;
	font-size: 12px;
	height: auto;
	line-height: 16px;
	max-width: 100%;
	min-height: 32px;
	overflow: visible;
	padding: 8px 15px 8px 27px;
	position: relative;
	text-align: left;
	white-space: normal;

	&::before {
		content: '\e912';
		font-family: 'icomoon', Arial, sans-serif;
		font-size: 16px;
		left: 6px;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}

	@media (--desktop) {
		display: block;
	}
}

.tippy-roundarrow svg,
.tippy-tooltip button {
	display: none;
}

.tippy-roundarrow:after {
	border-bottom: 8px solid transparent;
	border-right: 8px solid #2198d5;
	border-top: 8px solid transparent;
	content: '';
	display: block;
	height: 0;
	left: 5px;
	margin-top: -8px;
	position: absolute;
	top: 50%;
	width: 0;
}

.search-form-range-input:last-child {
	border-bottom-right-radius: 4px;
	border-top-right-radius: 4px;
}

.search-form-range-input:last-child .search-form-range-input__postfix {
	transform: translateY(-4px);
}

.search-form .search-form__cta {
	border-radius: 4px;
	font: normal 16px 'semibold', Arial, sans-serif;
	height: 44px;
	margin-bottom: 24px;
	padding: 10px 20px;

	@media (--desktop) {
		flex-basis: 165px;
		margin-bottom: 0;
		margin-left: 20px;
		width: 100%;
	}
}

.search-form__advanced {
	align-items: center;
	background: none;
	border: 0;
	color: var(--white);
	display: flex;
	font: 14px 'semibold', Arial, sans-serif;
	justify-content: center;
	padding: 0;
	text-decoration: none;

	&:hover,
	&:active,
	&:focus {
		outline: none;

		@media (--desktop) {
			color: var(--green-hover);
		}
	}

	@media (--desktop) {
		color: var(--green);
		height: 44px;
		margin-left: 32px;
	}
}

.search-form__advanced svg {
	fill: var(--white);
	margin-left: 8px;

	@media (--desktop) {
		fill: var(--green);
	}
}
/* Találati lista oldalon a kereső gombja sticky*/

.ALIST-app .search-form__cta {
	@media (--mobile-only) {
		bottom: 1px;
		font-weight: 600px;
		position: fixed;
		width: calc(100% - 48px);
		z-index: 2;
	}
}

.ANYIT-app .search-form .sf-radio-group__label {
	@media (--mobile-only) {
		color: var(--white);
	}
}
</style>
